import React from 'react';
export function Footer() {
  return <footer className="w-full bg-night-deep" data-id="element-128" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-129" data-mp="3gezev8fo7z39">
        <h3 className="font-display text-2xl font-bold tracking-tight text-shuttle" data-id="element-130" data-mp="3ghc5e9zhvhrx">
          Badminton Class Ready™
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-131" data-mp="36p6b2tlrso9k">
          The Court-Ready Progression Ladder™ — because planning a session
          shouldn&apos;t cost you every Sunday night.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-132" data-mp="39904ifsbca6">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-133" data-mp="3lf56wppurnlv">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-night-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-134" data-mp="3qf9sgu5mb8iy">
          Badminton Class Ready is an educational resource for coaches and
          teachers. It does not replace a coaching qualification, first-aid
          training, or the rules of your club, school, venue or governing body.
          Coaches are responsible for warm-ups, supervision and for checking that
          every activity is suitable for their players before it is run. No
          results are guaranteed. © Badminton Class Ready™ 2026 — All rights
          reserved.
        </p>
      </div>
    </footer>;
}